module.exports = __webpack_public_path__ + "img/p3_r.1565f8f1.jpg";